"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomsStatus = exports.OldCustomsStatus = void 0;
var OldCustomsStatus;
(function (OldCustomsStatus) {
    OldCustomsStatus["CustomsDeclarationAccepted"] = "CUSTOMS_DECLARATION_ACCEPTED";
    OldCustomsStatus["CustomsDeclarationReceived"] = "CUSTOMS_DECLARATION_RECEIVED";
    OldCustomsStatus["CustomsPortbaseNotificationConfirmation"] = "CUSTOMS_PORTBASE_NOTIFICATION_CONFIRMATION";
    OldCustomsStatus["GoodsArrivedRegistrationNumberReceived"] = "GOODS_ARRIVED_REGISTRATION_NUMBER_RECEIVED";
    OldCustomsStatus["GoodsArrivedWorkNumberReceived"] = "GOODS_ARRIVED_WORK_NUMBER_RECEIVED";
    OldCustomsStatus["InspectionRequired"] = "INSPECTION_REQUIRED";
    OldCustomsStatus["CustomsPhysicalExam"] = "CUSTOMS_PHYSICAL_EXAM";
    OldCustomsStatus["CustomsDocumentationExam"] = "CUSTOMS_DOCUMENTATION_EXAM";
    OldCustomsStatus["CustomsClearedGoodsReleased"] = "CUSTOMS_CLEARED_GOODS_RELEASED";
})(OldCustomsStatus = exports.OldCustomsStatus || (exports.OldCustomsStatus = {}));
var CustomsStatus;
(function (CustomsStatus) {
    CustomsStatus["OrderReceived"] = "order-received";
    CustomsStatus["DeclarationFiled"] = "declaration-filed";
    CustomsStatus["CustomsProcedure"] = "customs-procedure";
    CustomsStatus["DocumentsInspection"] = "documents-inspection";
    CustomsStatus["PhysicalInspection"] = "physical-inspection";
    CustomsStatus["CustomsCleared"] = "customs-cleared";
    CustomsStatus["CustomsRejected"] = "customs-rejected";
    CustomsStatus["InspectionRequired"] = "inspection-required";
})(CustomsStatus = exports.CustomsStatus || (exports.CustomsStatus = {}));
//# sourceMappingURL=customsStatus.model.js.map